if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {
  if (document.getElementById("attractions")) {
    setTimeout(function () {
      if (document.getElementsByClassName("btn").length > 0) {
        convertBtn();
      }
    }, 600);
  } else {
    if (document.getElementsByClassName("btn").length > 0) {
      convertBtn();
    }
  }

  $(".global-sitemap a").eq(0).attr("href", "/");

  // Remove empty <p> tags created by tinymce
  const paragraph = document.querySelectorAll("p") || [];
  paragraph.forEach(
    (e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
  );

  // avoid fancybox breaks slider.
  let internalGallery = $(".gallery-slides a");
  $(".gallery-slides a").on("click", function (e) {
    e.preventDefault();

    var totalSlides = +$(this).parents(".gallery-slides").slick("getSlick")
        .slideCount,
      dataIndex = +$(this).parents(".gallery-slides").data("slick-index"),
      trueIndex;
    switch (true) {
      case dataIndex < 0:
        trueIndex = totalSlides + dataIndex;
        break;
      case dataIndex >= totalSlides:
        trueIndex = dataIndex % totalSlides;
        break;
      default:
        trueIndex = dataIndex;
    }
    $.fancybox.open(internalGallery, {}, trueIndex);

    //console.log($(this).attr('data-slick-index'))
    $(".gallery-slides").slick("slickGoTo", $(this).attr("data-image"));

    return false;
  });
  //

  $(".sym-slides").slick({
    accessibility: false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          adaptiveHeight: true,
        },
      },
    ],
  });

  $(".gallery-slides").slick({
    accessibility: true,
    variableWidth: true,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          variableWidth: false,
          fade: true,
        },
      },
    ],
  });

  $(".partner-slider-js").slick({
    accessibility: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 500,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          variableWidth: false,
          fade: true,
        },
      },
    ],
  });

  $(".home-slides").slick({
    accessibility: false,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    pauseOnFocus: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          arrows: false,
        },
      },
    ],
  });

  $(".single-quad-slider__images").slick({
    accessibility: false,
    fade: true,
    asNavFor: ".single-quad-slider__info",
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          arrows: false,
        },
      },
    ],
  });

  $(".single-quad-slider__info").slick({
    accessibility: false,
    fade: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          arrows: false,
        },
      },
    ],
  });

  //For accordion quad
  $(".accordion .accordion__content").hide();
  //   $(".accordion .accordion__item:first")
  //     .addClass("active")
  //     .find(".accordion__content")
  //     .slideDown();
  $(".accordion .accordion__title:first").addClass("active");

  $(".accordion__item").click(function (e) {
    e.stopPropagation();

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).find(".accordion__content").slideUp();
    } else {
      $(".accordion__item.active .accordion__content").slideUp();
      $(".accordion__item.active").removeClass("active");
      $(this)
        .addClass("active")
        .find(".accordion__content")
        .slideDown(function () {
          $("html, body")
            .stop()
            .animate(
              { scrollTop: $(".accordion__item.active").offset().top - 100 },
              1000
            );
          //console.log($(".accordion__item.active").offset().top );
        });
    }
  });

  //email signup animation
  if (document.getElementById("email-signup_email_address")) {
    document
      .getElementById("email-signup_FNAME")
      .addEventListener("focus", function () {
        this.parentElement.classList.add("moved");
      });
    document
      .getElementById("email-signup_LNAME")
      .addEventListener("focus", function () {
        this.parentElement.classList.add("moved");
      });
    document
      .getElementById("email-signup_email_address")
      .addEventListener("focus", function () {
        this.parentElement.classList.add("moved");
      });
  }

  //search bar input animation
  if (document.getElementById("question")) {
    document.getElementById("question").addEventListener("focus", function () {
      this.parentElement.classList.add("moved");
    });
  }

  //CMS forms label animation
  if (document.getElementsByClassName("form-module__field").length > 0) {
    let allffields = document.getElementsByClassName("form-module__field");

    for (let j = 0; j < allffields.length; j++) {
      if (allffields[j].getElementsByTagName("input").length > 0) {
        if (
          allffields[j].getElementsByTagName("input")[0].type.toLowerCase() !=
            "checkbox" &&
          allffields[j].getElementsByTagName("input")[0].type.toLowerCase() !=
            "radio"
        ) {
          allffields[j]
            .getElementsByTagName("input")[0]
            .addEventListener("focus", function () {
              this.parentElement.classList.add("moved");
            });
        }
      }
      if (allffields[j].getElementsByTagName("select").length > 0) {
        allffields[j]
          .getElementsByTagName("select")[0]
          .addEventListener("focus", function () {
            this.parentElement.classList.add("moved");
          });
      }
      if (allffields[j].getElementsByTagName("textarea").length > 0) {
        allffields[j]
          .getElementsByTagName("textarea")[0]
          .addEventListener("focus", function () {
            this.parentElement.classList.add("moved");
          });
      }
    }
  }
  //Tripleseat forms label animation
  if (document.getElementById("tripleseat_embed_form")) {
    let alltdFields = document
      .getElementById("tripleseat_embed_form")
      .getElementsByTagName("td");

    for (let j = 0; j < alltdFields.length; j++) {
      if (alltdFields[j].getElementsByTagName("input").length > 0) {
        if (
          alltdFields[j].getElementsByTagName("input")[0].type.toLowerCase() !=
            "checkbox" &&
          alltdFields[j].getElementsByTagName("input")[0].type.toLowerCase() !=
            "radio"
        ) {
          alltdFields[j]
            .getElementsByTagName("input")[0]
            .addEventListener("focus", function () {
              this.parentElement.classList.add("moved");
            });
        }
        if (alltdFields[j].getElementsByTagName("input")[1]) {
          if (
            alltdFields[j]
              .getElementsByTagName("input")[1]
              .type.toLowerCase() == "checkbox" ||
            alltdFields[j]
              .getElementsByTagName("input")[1]
              .type.toLowerCase() == "radio"
          ) {
            alltdFields[j].classList.add("radio");
          }
        }
      }
      if (alltdFields[j].getElementsByTagName("select").length > 0) {
        alltdFields[j].classList.add("moved");
      }

      if (alltdFields[j].getElementsByTagName("textarea").length > 0) {
        alltdFields[j]
          .getElementsByTagName("textarea")[0]
          .addEventListener("focus", function () {
            this.parentElement.classList.add("moved");
          });
      }
    }
  }

  //vanilla JS fancybox
  if (document.getElementsByClassName("lightbox").length > 0) {
    let allLightboxes = document.getElementsByClassName("js-lightboxbtn");
    let allLightboxesLength = allLightboxes.length;

    for (let j = 0; j < allLightboxesLength; j++) {
      allLightboxes[j].addEventListener("click", function (e) {
        e.preventDefault();
        let currentTarget = this.getAttribute("href").split("#")[1];
        if (
          !document.getElementById(currentTarget).classList.contains("open")
        ) {
          document.getElementById(currentTarget).classList.add("open");
        } else {
          document.getElementById(currentTarget).classList.remove("open");
        }
      });
    }

    let allLightcloses = document.getElementsByClassName("js-lightboxclose");
    let allLightclosesLength = allLightcloses.length;

    for (let j = 0; j < allLightclosesLength; j++) {
      allLightcloses[j].addEventListener("click", function (e) {
        e.preventDefault();
        let currentTarget = this.parentElement.parentElement.id;
        if (
          !document.getElementById(currentTarget).classList.contains("open")
        ) {
          document.getElementById(currentTarget).classList.add("open");
        } else {
          document.getElementById(currentTarget).classList.remove("open");
        }
      });
    }
  }
})();

function convertBtn() {
  let allBtn = document.getElementsByClassName("btn");
  let allBtnLength = allBtn.length;
  for (let h = 0; h < allBtnLength; h++) {
    let InnerText = "";
    if (!allBtn[h].parentElement.classList.contains("form-module__submit")) {
      // cms form adds extra span
      InnerText = allBtn[h].innerHTML;
      allBtn[h].innerHTML = "<span>" + InnerText + "</span>";
    }
  }
}
